import styled from "styled-components";

export const Body = styled.div`
    display: flex;
    flex-grow: 1;
    overflow-y: auto;
    > * {
        width: 100%;
        min-height: 100%;
    }
`;
